var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerPublic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 59.847,
    viewBox: "0 0 50 59.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}.b{fill:#fff;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 50,
    height: 59.847,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43 -304.507)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 310.507)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-108-54.207A15.9,15.9,0,0,0-124-70a15.9,15.9,0,0,0-16,15.793c0,10.265,16,26.055,16,26.055s16-15.79,16-26.055",
    transform: "translate(149 76)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-299.451 72.805)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M367.181,247.842a2.7,2.7,0,0,1,.458.175l7.212,2.693.368-.125a2.963,2.963,0,0,0,.419-.16,2.92,2.92,0,1,0-2.459-5.3l-6.936,2.583a3.176,3.176,0,0,1,.889.118Z",
    transform: "translate(-2.907)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M376.754,258.081a3.39,3.39,0,0,0-1.273-.844l-.377-.143-8.346,3.105,7.991,2.979.732-.269a3.045,3.045,0,0,0,1.926-3.832A2.708,2.708,0,0,0,376.754,258.081Z",
    transform: "translate(-3.164 -6.113)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M362.572,256.815l.646.24h0l8.372-3.115.025-.009-6.992-2.612a2.549,2.549,0,0,0-.422-.161l-.044-.013a2.943,2.943,0,0,0-1.589,5.668Z",
    transform: "translate(0 -3.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M376.547,271.566a2.9,2.9,0,0,0-1.748-1.4l-.686-.257-7.167,2.7a2.942,2.942,0,0,1-1.267.288c-.094,0-.186-.01-.278-.019l7.357,2.748a3.316,3.316,0,0,0,.415.16,2.923,2.923,0,0,0,3.374-4.219Z",
    transform: "translate(-2.486 -12.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M364.432,269.224l6.958-2.6.026-.01-6.755-2.486-1.4-.511h0l-.649.251a3.272,3.272,0,0,0-1.943,1.918,2.878,2.878,0,0,0-.171.955,2.8,2.8,0,0,0,.176.975,2.51,2.51,0,0,0,.126.287,2.752,2.752,0,0,0,3.638,1.225Z",
    transform: "translate(-0.035 -9.37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPublic);
export default __webpack_public_path__ + "static/media/marker_public.51106f0da923293d9e409d54c930f03c.svg";
export { ForwardRef as ReactComponent };